import { Box } from '@mantine/core'

import { Contact as ContactType } from '@/types'

import ContactItem from './ContactItem'

interface Props {
  contacts: ContactType[]
}

export default function ContactCard({ contacts }: Props) {
  return (
    <Box>
      {contacts.map((contact: ContactType) => (
        <ContactItem key={contact.contact} contact={contact} />
      ))}
    </Box>
  )
}
